<template>
  <div>
    <my-head></my-head>
    <div class="zhaunrang minH">
      <div class="title">查看发布标的</div>
      <zr-details :id="$route.query.id"></zr-details>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
import ZrDetails from "../../components/ZrDetails.vue";
export default {
  components: {
    MyHead,
    MyFooter,
    ZrDetails,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">
.zhaunrang {
  width: 80%;
  margin: 24px auto 60px;
  padding: 0 30px;
}
</style>
